import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import "./styles.css";
import ShowVideo from "./pages/ShowVideo";
import Youtube from "./pages/Youtube";
import { UserProvider } from "./userContext";
import SearchResults from "./pages/SearchResults";
import Loading from  "./pages/loading";

//const API = "AIzaSyA2utTWIZ4p2TIOfc9GhIwLzl-rDZi-l7Q";
const API = "AIzaSyDIPQZ7ajUyhk49wX-Ws9pDbWgZJwWceLw";
//const API = "AIzaSyDdu0hwwA0V-9W23SCEFU8U19GXtXbLaL4";
//const API="AIzaSyD5WUhCKYhKGO5j68zpVepihvbS-cTqlQ0";
//const API = "AIzaSyBAgwYUvn0ulTABZm04ihw--tCfhEMbyvA";
//const API = "AIzaSyCmzjJ6U9XHTxRAT2zrOvJikJFxGfbzhuY";


const mostpop = `https://www.googleapis.com/youtube/v3/search?part=snippet&maxResults=20&q=Netfleix+India&regionCode=IN&type=video&key=${API}`;
//const mostpop=`https://www.googleapis.com/youtube/v3/search?key=${API}&channelId=UCAh9DbAZny_eoGFsYlH2JZw&part=snippet,id&order=date&time&maxResults=2`;
//const mostpop = `https://www.googleapis.com/youtube/v3/search?part=snippet&maxResults=2&q=Live+news+Hindi&regionCode=IN&type=video&key=${API}`;
 
class App extends Component {
  constructor(props) {
    super(props);
    this.state = { popular: "", loading: true, query: "", songs: "" ,news:"",conten:""};
  }

  async componentDidMount() {
    const response = await fetch(mostpop);
    const search = await fetch(
      `https://www.googleapis.com/youtube/v3/search?part=snippet&maxResults=20&q=Trending+Songs&regionCode=IN&type=video&key=${API}`
    );
    const searchNews = await fetch(
      `https://www.googleapis.com/youtube/v3/search?part=snippet&maxResults=20&q=Live+news+India&regionCode=IN&type=video&key=${API}`
    );

    
    const data = await response.json();
    
    const datasearch = await search.json();

    const dataNews=await searchNews.json();
    this.setState({ popular: data, loading: false, songs: datasearch ,news:dataNews});
  }

  render() {
    if (this.state.loading) {
      return (
        <>
          <Loading/>
        </>
      );
    } else if (this.state.query !== "") {
      return (
        <>
          <SearchResults api={API} value={this.state} />
        </>
      );
    } else {
      return (
        <>
          <div className="nav-bar">
            <ul>
              <li>
                <a href="/">
                <h1>
                  <span>Flex</span>
                  <span>Tube</span>
                </h1>
                </a>
              </li>
              <li>
                <input
              
                  id="Searchbox"
                  name="SearchBox"
                  placeholder="Search"
                  onMouseLeave={(e) =>
                    this.setState({ query: e.target.value })
                  }
                />
              </li>
            </ul>
          </div>
          <Router>
            <Switch>
              <Route
                exact
                path="/"
                component={(props) => (
                  <UserProvider value={this.state}>
                    <Youtube />
                  </UserProvider>
                )}
              />
              <Route exact path="/:id" component={ShowVideo} />
            </Switch>
          </Router>
        </>
      );
    }
  }
}

export default App;
